<template>
  <ui-button
    block
    size="lg"
    type="submit"
    class="quiz-submit--button"
    :class="{ submitted: isSubmitted }"
    :disabled="isSubmitButtonDisabled"
    @click="onClickSubmit"
  >
    <!-- new code: flatten the logic to make it more understandable -->
    <span v-if="canSubmit">{{ $t("submit") }}</span>
    <span v-if="isSubmitted && !isTimesUp && !isSubmissionClosed">{{
      $t("submitted")
    }}</span>
    <template v-if="isSubmissionClosed">
      <span>{{ $t("submissionClosedButton") }}</span>
      <i class="fa fa-lock" />
    </template>
    <span v-if="isTimesUp">{{ $t("submit") }}</span>
    <CountDownTimer v-if="isShowCountdownTimer" />
  </ui-button>
</template>

<script>
import { mapState } from 'vuex'
import UiButton from '@/components/UI/Button'
import CountDownTimer from '@/components/CountDownTimer'

export default {
  components: {
    UiButton,
    CountDownTimer,
  },
  props: {
    // This depends on the QuizForm parent component.
    // If audience haven't pick any option, 'disabled' will be true.
    disabled: {
      type: Boolean,
      required: true,
    },
    isFormSubmitted: {
      type: Boolean,
      default: false,
    },
    isWaitingCallApi: {
      type: Boolean,
      default: false,
    },
    isMultipleChoice: {
      type: Boolean,
      default: false,
    },
    isWaitingQuizResult: {
      type: Boolean,
      default: false,
    },
    timeAnswer: {
      type: Number,
      default: 0,
    },
    timeToAnswer: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isSubmitted: false,
    }
  },

  computed: {
    ...mapState({
      slide: (state) => state.slide,
      hasTimeLimitOption: (state) => {
        return (
          state.slide.type === 'imageChoice' ||
          state.slide.type === 'multipleChoice' ||
          state.slide.type === 'openEnded' ||
          state.slide.type === 'wordCloud'
        )
      },
    }),
    canSubmit() {
      return !this.isSubmitted && !this.isTimesUp && !this.isSubmissionClosed
    },
    isTimesUp() {
      if (this.isSubmitted) {
        return this.timeToAnswer > 0 && this.timeAnswer >= this.timeToAnswer
      }
      return this.isWaitingQuizResult
    },
    isSubmitButtonDisabled() {
      return (
        this.disabled ||
        this.isSubmitted ||
        this.isWaitingQuizResult ||
        this.timeAnswer > this.timeToAnswer
      )
    },
    isSubmissionClosed() {
      return this.isMultipleChoice && this.slide && this.slide.stopSubmission
    },

    isShowCountdownTimer() {
      // Only show countdown timer in the Submit button for these slide types:
      // poll, open ended, wordcloud
      if (this.hasTimeLimitOption) return !this.isSubmissionClosed
      return false
    },
  },

  watch: {
    isFormSubmitted(isFormSubmitted) {
      // handle when using keyboard to to trigger submit
      this.isSubmitted = isFormSubmitted
    },
  },

  methods: {
    onClickSubmit() {
      if (this.isSubmitButtonDisabled) {
        return
      }
      if (!this.isWaitingCallApi) {
        this.isSubmitted = true
      }

      this.$emit('submit')
    },
    getButtonText() {
      if (!this.isSubmitted) {
        return this.$t('submit')
      }

      return this.$t('submitted')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.quiz-submit--button {
  height: 52px;
  width: 100%;
  margin-top: 20px;
  border-radius: 26px;
  padding: 11px 43px 11px 43px;
  font-weight: bold;
  background: $primary-color;
  &:not(.submitted):not(:disabled):hover {
    background: darken($primary-color, 10%);
  }
  &:disabled {
    background: #89befa;
  }
}
</style>
